import { apiSlice } from "../apiSlice";

export interface CartApiResponse {
  carts: any;
}

export interface LiveLocation {
  _latitude: number;
  _longitude: number;
  langitude?: number; // API returns langitude (typo in API)
  timestamp?: any;
}

export interface CartByIdResponse {
  id: string;
  name: string;
  liveLocation?: LiveLocation;
  driverName?: string;
  driverPhone?: string;
  restaurantId?: string;
  status?: string;
  [key: string]: any; // Allow additional properties
}

export interface Category {
  display: string;
  image: string;
  score: number;
}
const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PRODUCTION;
export const cartService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCartListByRestaurantId: builder.query<CartApiResponse, string>({
      query: (restaurantId) => ({
        url: `https://customersitehttps-getcartlistbyrestaurantid-${API_BASE_DOMAIN}-uc.a.run.app?restaurantId=${restaurantId}`,
        method: "GET",
      }),
      keepUnusedDataFor: 600,
    }),
     getCartById: builder.query<CartByIdResponse, string>({
      query: (cartId) => ({
        url: `https://userhttps-getcartbyid-${API_BASE_DOMAIN}-uc.a.run.app`,
        method: "GET",
        params: { cartId },
      }),
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { 
  useGetCartListByRestaurantIdQuery,
  useLazyGetCartListByRestaurantIdQuery,
  useGetCartByIdQuery 
} = cartService;
